import { isEqual } from 'lodash';
import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';
import { ILayerProps } from '@meitu/saas-editor-core/es/version-types';
import { IThresholdIdMap } from '@/types';

export interface ISvipWatermarkModel {
    destroy: () => void;
    /** 是否展示水印 */
    isRenderWatermark: boolean;
    setIsRenderWatermark: (payload: boolean) => void;

    /** 是否会员模板 */
    isVipTemplate: boolean;
    setIsVipTemplate: (payload: boolean) => void;

    /** 会员素材对应的图层 */
    thresholdToLayersMap: Map<string, string[]>;
    setThresholdToLayersMap: (payload: Map<string, string[]>) => void;

    /** 应用中的会员素材信息列表 */
    materialList: IThresholdIdMap[];
    setMaterialList: (payload: IThresholdIdMap[]) => void;

    /** 接口素材信息缓存 */
    thresholdIdMap: Map<string, IThresholdIdMap>;
    setThresholdIdMap: (payload: Map<string, IThresholdIdMap>) => void;

    /** 舞台上用到素材 */
    stageMaterialIdMap: Map<number, string[]>;
    setStageMaterialIdMap: (payload: Map<number, string[]>) => void;

    /** 舞台上用到素材对应的标签id（分类id） */
    stageMaterialLabelMap: Map<number, number | string>;
    setStageMaterialLabelMap: (payload: { materialId: number; labelId: number | string }) => void;

    /** 最终渲染的水印图层数据 */
    finalWatermarkData: Map<number, { watermarkLayers: ILayerProps[]; isGlobal: boolean }>;
    setFinalWatermarkData: (payload: Map<number, { watermarkLayers: ILayerProps[]; isGlobal: boolean }>) => void;
}
const useSvipWatermarkModel = create<ISvipWatermarkModel>()(
    immer((set) => ({
        destroy: () =>
            set((state) => {
                state.finalWatermarkData = new Map();
                state.stageMaterialLabelMap = new Map();
                state.isRenderWatermark = false;
                state.isVipTemplate = false;
                state.materialList = [];
                state.stageMaterialIdMap = new Map();
                state.thresholdIdMap = new Map();
                state.thresholdToLayersMap = new Map();
            }),
        isRenderWatermark: false,
        setIsRenderWatermark: (payload) =>
            set((state) => {
                if (payload !== state.isRenderWatermark) state.isRenderWatermark = payload;
            }),

        isVipTemplate: false,
        setIsVipTemplate: (payload) =>
            set((state) => {
                state.isVipTemplate = payload;
            }),

        thresholdToLayersMap: new Map(),
        setThresholdToLayersMap: (payload) =>
            set((state) => {
                state.thresholdToLayersMap = new Map(payload);
            }),

        materialList: [],
        setMaterialList: (payload) =>
            set((state) => {
                if (!isEqual(state.materialList, payload)) {
                    state.materialList = payload;
                }
            }),

        thresholdIdMap: new Map(),
        setThresholdIdMap: (payload) =>
            set((state) => {
                state.thresholdIdMap = new Map(payload);
            }),

        stageMaterialLabelMap: new Map(),
        setStageMaterialLabelMap: (payload) =>
            set((state) => {
                state.stageMaterialLabelMap.set(payload.materialId, payload.labelId);
            }),
        stageMaterialIdMap: new Map(),
        setStageMaterialIdMap: (payload) =>
            set((state) => {
                state.stageMaterialIdMap = new Map(payload);
            }),

        finalWatermarkData: new Map(),
        setFinalWatermarkData: (payload) =>
            set((state) => {
                state.finalWatermarkData = new Map(payload);
            }),
    })),
);

export { useSvipWatermarkModel };
export const getSvipWatermarkModel = () => useSvipWatermarkModel.getState();
